import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import axios from "axios";
import { Text } from "components";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useEffect, useState } from "react";
import { FaLock, FaUser } from "react-icons/fa"; // Import icons from react-icons
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { IoAddCircle } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import UpdateEwayBillLogin from "./UpdateEwayBillLogin";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

function EwayBillLoginList() {
  const [ewaybillLogin, setEwaybillLogin] = useState(null);
  const [deliveryewaybill, setDeliveryEwayBill] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordDC, setShowPasswordDC] = useState(false);
  const [taxVisible, setTaxVisible] = useState(false);
  const [deliVisible, setdeliVisible] = useState(false);
  let navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    GetTaxEwayBillLogin();
    setTimeout(() => {
      GetDeliveryEwayBillLogin();
    }, 500);
  }, [taxVisible, deliVisible]);

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const togglePasswordDC = () => {
    setShowPasswordDC((prev) => !prev);
  };

  const GetTaxEwayBillLogin = () => {
    axios
      .post("/api/purple-fusion/ewaybill/login/taxinvoice/get", {}, headers)
      .then((response) => {
        setEwaybillLogin(response.data[0]);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetDeliveryEwayBillLogin = () => {
    axios
      .post(
        "/api/purple-fusion/ewaybill/login/deliverychallan/get",
        {},
        headers
      )
      .then((response) => {
        setDeliveryEwayBill(response.data[0]);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="flex p-2 flex-row w-full items-center">
        <Text
          className="text-base md:text-[22px]  text-gray-800 sm:text-xl tracking-[0.20px] w-[85px] whitespace-nowrap"
          size="txtInterSemiBold24"
        >
          E-way Bill Login Credentials
        </Text>
      </div>
      <div className="bg-gray-100 flex items-center justify-center gap-32 mx-2 my-3 p-8">
        <div className="max-w-sm w-full bg-white-A700 border border-gray-300 rounded-lg shadow-lg p-6">
          {/* Display user details if logged in */}
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0 bg-blue-100 p-3 rounded-full">
              <FaUser className="text-blue-500 w-6 h-6" />
            </div>
            <h2 className="ml-3 text-base font-bold text-gray-800">
              E-way Bill Tax Invoice Login Credintials
            </h2>
          </div>
          {ewaybillLogin ? (
            <div>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <FaUser className="text-gray-500 w-5 h-5" />
                  <div>
                    <span className="block text-sm font-medium text-gray-600">
                      Username
                    </span>
                    <span className="block text-sm font-semibold text-gray-900">
                      {ewaybillLogin?.username}
                    </span>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <FaLock className="text-gray-500 w-5 h-5" />
                  <div className="relative w-full">
                    <span className="block text-sm font-semibold text-gray-900 pr-6">
                      {showPassword ? ewaybillLogin?.password : "••••••••"}
                    </span>
                    <button
                      onClick={togglePassword}
                      type="button"
                      className="absolute right-0 top-1/2 transform -translate-y-1/2 pr-1 focus:outline-none"
                    >
                      {showPassword ? (
                        <FaEyeSlash className="text-gray-500 w-4 h-4" />
                      ) : (
                        <FaEye className="text-gray-500 w-4 h-4" />
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <button
                onClick={
                  () => setTaxVisible(true)
                  // navigate("/create/ewaybill/login", {
                  //   state: { message: "taxinvoice" },
                  // })
                }
                className="mt-6 w-full bg-blue-500 hover:bg-blue-600 text-white-A700 font-semibold py-2 px-4 rounded-lg"
              >
                Edit
              </button>
              {taxVisible && (
                <UpdateEwayBillLogin
                  ewaybillLogin={ewaybillLogin}
                  flag="taxinvoice"
                  setTaxVisible={setTaxVisible}
                />
              )}
            </div>
          ) : (
            <button
              onClick={() =>
                navigate("/create/ewaybill/login", {
                  state: { message: "taxinvoice" },
                })
              }
              className="text-blue-500 hover:text-blue-600"
            >
              {" "}
              <IoAddCircle size={30} style={{ cursor: "pointer" }} />
            </button>
          )}
        </div>

        <div className="max-w-sm w-full bg-white-A700 border border-gray-300 rounded-lg shadow-lg p-6">
          {/* Display user details if logged in */}
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0 bg-blue-100 p-3 rounded-full">
              <FaUser className="text-blue-500 w-6 h-6" />
            </div>
            <h2 className="ml-3 text-base font-bold text-gray-800">
              E-way Bill delivery Challan Login Credintials
            </h2>
          </div>
          {deliveryewaybill ? (
            <div>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <FaUser className="text-gray-500 w-5 h-5" />
                  <div>
                    <span className="block text-sm font-medium text-gray-600">
                      Username
                    </span>
                    <span className="block text-sm font-semibold text-gray-900">
                      {deliveryewaybill?.username}
                    </span>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <FaLock className="text-gray-500 w-5 h-5" />
                  <div className="relative w-full">
                    <span className="block text-sm font-semibold text-gray-900 pr-6">
                      {showPasswordDC ? deliveryewaybill?.password : "••••••••"}
                    </span>
                    <button
                      onClick={togglePasswordDC}
                      type="button"
                      className="absolute right-0 top-1/2 transform -translate-y-1/2 pr-1 focus:outline-none"
                    >
                      {showPasswordDC ? (
                        <FaEyeSlash className="text-gray-500 w-4 h-4" />
                      ) : (
                        <FaEye className="text-gray-500 w-4 h-4" />
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <button
                onClick={
                  () => setdeliVisible(true)
                  // navigate("/update/ewaybill/login", {
                  //   state: { message: "deliverychallan" },
                  // })
                }
                className="mt-6 w-full bg-blue-500 hover:bg-blue-600 text-white-A700 font-semibold py-2 px-4 rounded-lg"
              >
                Edit
              </button>
              {deliVisible && (
                <UpdateEwayBillLogin
                  deliveryewaybill={deliveryewaybill}
                  flag="deliverychallan"
                  setdeliVisible={setdeliVisible}
                />
              )}
            </div>
          ) : (
            <button
              onClick={() =>
                navigate("/create/ewaybill/login", {
                  state: { message: "deliverychallan" },
                })
              }
              className="text-blue-500 hover:text-blue-600"
            >
              {" "}
              <IoAddCircle size={30} style={{ cursor: "pointer" }} />
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default EwayBillLoginList;
